import { mapGetters, mapState } from 'vuex';


export default {
  computed: {
    ...mapState({
      username: state => state.auth.data.username,
      role: state => state.auth.data.role
    }),
    ...mapGetters([
      'hasPermission',
      'hasRole'
    ])
  }
};
